import { Icon } from '@iconify/react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Form, Formik } from 'formik'
import { useIsMutating } from '@tanstack/react-query'

import { Button, Checkbox, Input, Modal } from '@pepper/ui'

import {
  FormValues,
  purposeOptions,
  validationSchema,
} from './BulkDownloadModal.utils'
import styles from './BulkDownloadModal.module.css'

interface Props {
  handleSubmit: (purpose: { purpose: string; message?: string }[]) => void
}

function BulkDownloadModal({ handleSubmit }: Props): JSX.Element {
  const initialValues: FormValues = { purpose: [] }

  const { visible, remove } = useModal()
  const isMutatingBulkDownloads = useIsMutating({
    mutationKey: ['bulk-export'],
  })

  const _handleSubmit = async (values: FormValues) => {
    const exportPurpose = values.purpose.map(item => ({
      purpose: item,
      message: values[`${item}_message`]?.toString(),
    }))
    handleSubmit(exportPurpose)
  }

  return (
    <Modal
      visible={visible}
      onCancel={remove}
      footer={null}
      className={styles.modal}
    >
      <header className={styles.header}>
        <div>
          <h2 className={styles.headerTitle}>
            Let us know what was the purpose of Download*
          </h2>
          <p className={styles.headerDescription}>
            This initiative aims to better understand our customers and cater to
            their needs
          </p>
        </div>
        <button
          className={styles.closeIcon}
          aria-label="Close"
          onClick={remove}
        >
          <Icon icon="fe:close" width="16" height="16" />
        </button>
      </header>

      <Formik<FormValues>
        onSubmit={_handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnMount={true}
      >
        {({ values, setFieldValue, isValid }) => (
          <Form>
            {purposeOptions.map(option => (
              <fieldset key={option.value} className={styles.fieldset}>
                <Checkbox
                  name={option.value}
                  value={values.purpose.includes(option.value)}
                  className={styles.purposeCheckbox}
                  onChange={event => {
                    const _values = values.purpose
                    if (event.target.checked) {
                      _values.push(option.value)
                      setFieldValue('purpose', _values)
                    } else {
                      setFieldValue(
                        'purpose',
                        _values.filter(value => value !== option.value)
                      )
                    }
                  }}
                >
                  {option.label}
                </Checkbox>
                {option.otherField && values.purpose.includes(option.value) && (
                  <Input
                    name={`${option.value}_message`}
                    placeholder={option.otherField.placeholder}
                    className={styles.messageInput}
                    onChange={event =>
                      setFieldValue(
                        `${option.value}_message`,
                        event.target.value
                      )
                    }
                  />
                )}
              </fieldset>
            ))}

            <div className={styles.ctaContainer}>
              <Button
                htmlType="submit"
                type="primary"
                loading={isMutatingBulkDownloads > 0}
                disabled={!isValid}
              >
                Continue
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NiceModal.create<Props>(BulkDownloadModal)
